export const voiceKeys = {
	all: ["voice"] as const,
	messages: () => [...voiceKeys.all, "message"] as const,
	message: (friendId: number) => [...voiceKeys.messages(), friendId] as const,
	urls: () => [...voiceKeys.all, "url"] as const,
	url: (messageId: string | null) => [...voiceKeys.urls(), messageId] as const,
} as const
